module.exports = window["wcPPCP"]["blockData"];